import * as type from './UserType';
const initialState = {
    userInfo: {},
    polyclinics: [],
    changingClinic: false,
    workspace: {
        clinic: null,
        polyclinic: null
    },
    users: null,
    user: null,
    userFound: null
};
export const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case type.GET_POLYCLINICS.SUCCESS:
            return { ...state, polyclinics: action.payload };
        case type.SET_WORKSPACE:
            return { ...state, workspace: action.payload };
        case type.IS_CHANGING_CLINIC:
            return { ...state, changingClinic: action.payload };
        case type.USER_INFO:
            return { ...state, userInfo: action.payload };
        case type.DELETE_WORKSPACE:
            return { ...state, workspace: null };
        case type.CREATE_USER:
            return { ...state, user: action.payload, users: [action.payload, ...state.users] };
        case type.GET_USERS.SUCCESS:
            return { ...state, users: [...action.payload] };
        case type.GET_USER.SUCCESS:
            return { ...state, user: { ...action.payload } };
        case type.USER_FOUND.SUCCESS:
            return { ...state, userFound: action.payload };
        case type.USER_FOUND.FAILURE:
            return { ...state, userFound: {} };
        case type.RESET_USER_FOUND:
            return { ...state, userFound: null };
        case type.EDIT_USER_ACCESS: {
            const { id, data, isYou, namespace } = action.payload;
            const existUser = state.users.find((user) => user.id === id);
            const editedUsers = state.users.map((item) => (item.id === id ? data : item));
            const namespaces = state.userInfo.namespaces.map((item) =>
                item.id === namespace ? { ...item, access: data.namespace_access } : item
            );

            if (!existUser) {
                return {
                    ...state,
                    users: [data, ...state.users],
                    userInfo: { ...state.userInfo }
                };
            } else {
                const editedUserInfo = isYou
                    ? { ...state.userInfo, namespaces }
                    : { ...state.userInfo };
                return { ...state, users: editedUsers, userInfo: editedUserInfo };
            }
        }
        case type.DELETE_USER:
            return { ...state, users: state.users.filter((item) => item.id !== action.payload) };
        case type.UPDATE_USER_INFO: {
            const updatedUserInfo = { ...state.userInfo, ...action.payload };
            return { ...state, userInfo: updatedUserInfo };
        }
        default:
            return state;
    }
};
